import script from "./CustomCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./CustomCheckbox.vue?vue&type=style&index=0&id=03abdd9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03abdd9f"]])

export default __exports__